'use client'

import * as React from 'react'
import { useRouter } from 'next/navigation'
import { ToastProvider } from '@heroui/react'
import { HeroUIProvider } from '@heroui/system'
import type { ThemeProviderProps } from 'next-themes'
import { ThemeProvider as NextThemesProvider } from 'next-themes'

export interface ProvidersProps {
	children: React.ReactNode
	themeProps?: ThemeProviderProps
}

export function ThemeProvider({ children, ...themeProps }: ThemeProviderProps) {
	const router = useRouter()

	// 在Next.js App Router中，使用useRouter钩子并传递navigate函数
	return (
		<HeroUIProvider navigate={router.push}>
			<ToastProvider placement="top-center" toastOffset={60} />
			<NextThemesProvider
				attribute='class'
				defaultTheme='light'
				enableSystem={false}
				disableTransitionOnChange
				{...themeProps}
			>
				{children}
			</NextThemesProvider>
		</HeroUIProvider>
	)
}
